import React, { useCallback } from 'react';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import Lupa from '@panel/commons/assets/icons/Lupa.svg';
import { getColor } from '@panel/commons/core/themev3';

const Searchbox = ({ value, handleChange, handleSubmit, placeholder }) => {
  const handlerWrapper = useCallback(
    e => {
      e.preventDefault();
      if (value) {
        handleSubmit(e);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value, handleSubmit]
  );

  return (
    <FormContainer onSubmit={handlerWrapper}>
      <input
        data-panel='postingsBar-searchBox'
        type='text'
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
      />
      <button data-panel='postingsBar-searchBox-submit' type='submit'>
        <div />
      </button>
    </FormContainer>
  );
};

const FormContainer = styled.form`
  input {
    height: 48px;
    width: 100%;
    border-radius: 8px;
    border: 1px solid ${select('midLightGray')};
    background-color: ${select('white')};
    padding: 13px 30px 13px 12px;
    font-family: 'Hind';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    &:focus {
      border: 1px solid ${getColor('primary')};
    }
  }
  button {
    width: 16px;
    height: 16px;
    position: relative;
    left: -30px;
    top: 4px;
    display: inline;
    cursor: pointer;
    > div {
      background-image: ${`url(${Lupa})`};
      width: 16px;
      height: 16px;
    }
  }
`;

export default Searchbox;
